import { Schema } from "effect";
import {
  AccountId,
  ConversationId,
  ConversationTimelineEventId,
} from "../../../../ids/definitions";
import {
  MongoCustomerId,
  MongoRuleId,
  MongoUserId,
} from "../../../../ids/mongo-ids";
import {
  ConversationTimelineEvent,
  TimelineActorType,
  TimelineEventType,
} from "./timeline-event";

/**
 * Response schema for timeline events returned from the RPC endpoint.
 * Uses the full discriminated union for eventData to preserve type safety.
 */
export const ConversationTimelineEventResponse = Schema.Struct({
  id: ConversationTimelineEventId,
  conversationId: ConversationId,
  accountId: AccountId,
  actorType: TimelineActorType,
  actorMongoUserId: Schema.NullOr(MongoUserId),
  actorMongoCustomerId: Schema.NullOr(MongoCustomerId),
  actorMongoRuleId: Schema.NullOr(MongoRuleId),
  parentEventId: Schema.NullOr(ConversationTimelineEventId),
  eventType: TimelineEventType,
  eventData: Schema.Unknown,
  occurredAt: Schema.Date,
});

export interface ConversationTimelineEventResponse
  extends Schema.Schema.Type<typeof ConversationTimelineEventResponse> {}

/**
 * Converts a validated ConversationTimelineEvent to the response format.
 */
export function toTimelineEventResponse(
  event: ConversationTimelineEvent,
): ConversationTimelineEventResponse {
  return {
    id: event.id,
    conversationId: event.conversationId,
    accountId: event.accountId,
    actorType: event.actorType,
    actorMongoUserId: event.actorMongoUserId,
    actorMongoCustomerId: event.actorMongoCustomerId,
    actorMongoRuleId: event.actorMongoRuleId,
    parentEventId: event.parentEventId,
    eventType: event.eventType,
    eventData: event.eventData,
    occurredAt: event.occurredAt,
  };
}
